module.exports = __webpack_public_path__ + "img/statistics_grey.59461443.svg";